import { render, staticRenderFns } from "./AvailabilityStatus.vue?vue&type=template&id=2cf0ed70&"
import script from "./AvailabilityStatus.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports